<template>
  <div class="app-header">
    <div class="header-title">
      <div class="header-title-content">
        <div>您好，欢迎访问河北自贸区产业投资集团采购系统~</div>
        <div style="color: #2299FC;font-size: 12px;">服务热线：0311-82451129</div>
      </div>
    </div>
    <div class="header-top">
      <div class="header-top-content">
        <div class="header-top-title"  @click="imgClick">
          <!--          <el-image style="width: 32px;height: 58.43px" :src="require('@@/assets/logo.png')"></el-image>-->
          <el-image style="width: 526px;height: 64px" :src="require('@@/assets/logo2.png')"></el-image>
          <!--          <div style="margin-bottom: 10px;display: flex;justify-content: left;align-items: center"> <span style=" margin: 0 12px;display: inline-block;background: #014278 ;width: 1px;height: 32px;"></span> <span  style="font-family: Alibaba PuHuiTi 3.0, Alibaba PuHuiTi 30;font-weight: normal;color: #014379;font-size: 20px" > &nbsp;电子采购系统</span></div>-->
        </div>
        <div class="header-top-input" style="margin-bottom: 10px;background: #FFFFFF;border-radius: 4px 4px 4px 4px;border: 1px solid #DCDCDC;">
          <el-input  placeholder="请输入招标公告名称" v-model="queryParams.ggName">
            <el-button  slot="append" icon="el-icon-search" style="color: #014379;font-size: 13px;" @click="getZbggType"></el-button>
          </el-input>
        </div>
      </div>
    </div>
    <div class="header-router">
      <div class="header-elMenu">
        <el-menu mode="horizontal" :default-active="current" active-text-color="#FFF" text-color="#FFF" @select="handleSelect">
          <template v-for="(item,index) in menuItems">
            <el-menu-item v-if="!item.children || !item.children.length" :key="item.location" :index="item.location">
              <a  :href="item.location" @click.prevent >{{ item.label }}</a>
            </el-menu-item>
            <el-submenu v-else :key="item.location" :index="item.location">
              <template slot="title"><span >{{ item.label }}</span></template>
              <el-menu-item v-for="child in item.children" :key="child.location" style="height: 60px;">
                <a :href="child.location" @click.prevent>{{ child.label }}</a>
              </el-menu-item>
            </el-submenu>
          </template>
        </el-menu>
      </div>
    </div>
  </div>
</template>

<script>

import {getGgList} from "@/api/api";

export default {
  data() {
    return {
      current: "/home",
      menuItems: [
        {label: "首页", location: "/home",},
        {label: "采购信息", location: "/about",},
        // {label: "保函系统", location: "/guarantee",},
        // {label: "竞价大厅", location: "/Bidding",},
        {label: "下载中心", location: "/download",},
        {label: "关于我们", location: "/ourself",},
      ],
      queryParams:{}
    };
  },
  created() {
    let menu = sessionStorage.getItem("menu");
    this.current = menu ? (menu == "/" ? "/home" : menu) : "/home";
  },
  mounted() {
    this.$bus.$on("changeMainNav", (data) => {
      this.current = data
    });
  },
  methods: {
    gotoCA(){
      window.open("https://hebcaonline.hebca.com/Hebca/foreground/eseal/applyCertAndAutoSignPage.action?projectType=gzzcdzzb&cztype=1&certType=null")
    },
    // 顶部导航跳转
    handleSelect(path) {
      if(path){
        this.toPage(path);
      }else {
        this.$message.warning('暂未开放')
      }
    },
    // 页面跳转
    toPage(path, val) {
      if (path == '/guarantee') window.open('guarantee/')
      if (path == '/bidEvaluationOffice') window.open('/bidEvaluationOffice/')
      // if(path === '/ShoppingMall') window.open('http://eb.hengyuanreli.com:8200/shop/ui/buyer/#/')
      this.$router.push({path: path, query: {type: val}});
    },

    imgClick(){
      this.$router.push({path: "/home",});
    },
    getZbggType(){
      getGgList(this.queryParams).then((res) => {
        if (res.code === 200) {
          if(res.data.items.length>0){
            let routeData = this.$router.resolve({path: "/about", query: {ggName: this.queryParams.ggName}});
            //必要操作，否则不会打开新页面
            window.open(routeData.href, '_blank');
            this.queryParams.ggName = ''
          }else {
            this.$message.warning('请输入正确的招标公告名称')
          }
        }
      });
    },
  },
  watch: {
    '$route': {
      immediate: true,
      handler(n) {
        if (n.path.indexOf('about') != -1) {
          this.$nextTick(() => this.current = '/about')
        } else {
          this.$nextTick(() => this.current = n.path)
        }
      }
    }
  }
};
</script>
<style scoped lang="less">
.app-header{
  margin: 0;
  padding: 0;
  width: 100%;

}
.header-title{
  background: #FFFFFF;
  height: 28px;
  width: 100%;
  font-family: 'Arial Normal', 'Arial', sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 13px;
  letter-spacing: normal;
  color: #333333;
  text-align: center;
  line-height: normal;
  text-transform: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.header-title-content{
  max-width: 1360px;
  min-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.header-top{
  width: 100%;
  height: 144px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top:10px ;
  box-sizing: border-box;
  background: url("@/assets/images/header/background.png");
}
.header-router{
  width: 100%;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #118DF2;

}
.header-top-content{
  max-width: 1360px;
  min-width: 1204px;
  margin: 0 auto ;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.header-top-title{
  display: flex;
  justify-content: left;
  align-items: flex-end;
}

.header-elMenu{
  max-width: 1360px;
  min-width: 1204px;
  height: 100%;
  color: #fff;
}
::v-deep .el-input__inner{
  background: transparent !important;
  width: 383px;
  //border-left: 1px solid #E2E2E3;
  //border-top: 1px solid #E2E2E3;
  //border-bottom: 1px solid #E2E2E3;
  //border-right: none;
  border: none;
}
::v-deep.el-input__inner:focus{
  border: 1px solid #E2E2E3;
}
.header-top-input ::v-deep .el-input-group__append{
  background-color: #fff;
  //border-right: 1px solid #E2E2E3;
  //border-top: 1px solid #E2E2E3;
  //border-bottom: 1px solid #E2E2E3;
  //border-left: none;
  border: none;
}
.header-top-input{
  border: 1px solid #E2E2E3;
  border-radius: 4px;
}
::v-deep .el-menu{
  width: 100% ;
  height: 44px;
  display: flex;
  justify-content: left;
  align-items: center;
  background: transparent !important;
}
::v-deep .el-menu-item {
  height: 44px;
  font-size: 18px;
  font-weight: normal;
  font-family: Alibaba PuHuiTi 3.0, Alibaba PuHuiTi 30;
  line-height: 44px !important;
  width: calc(100% / 4);
  text-align: center;
}
::v-deep .el-menu.el-menu--horizontal {
  border-bottom: none;
}
& > div {
  height: inherit;
  align-items: center;
}

::v-deep .el-menu--horizontal > .el-menu-item.is-active {
  border:none;
  background-color: #FF3030 ;
}
::v-deep .el-menu-item:focus, .el-menu-item:hover{
  background-color: #FF3030 !important;
  color: #fff !important;
}
</style>
